"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
const useStyles = props => {
  const {
    getMeasurement
  } = (0, _useStylesUtils.useStylesUtils)();
  const {
    type = 'inline',
    width = 'auto',
    height = 'auto',
    background = 'transparent',
    zIndex = 1
  } = props;
  const ccPreloaderStyle = (0, _react.useMemo)(() => {
    const typeProps = () => {
      switch (type) {
        case 'fullscreen':
          {
            return {
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            };
          }
        case 'over':
          {
            return {
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            };
          }
        default:
          {
            return {
              position: 'static',
              margin: '0 auto'
            };
          }
      }
    };
    const ccPreloader = (0, _css.css)({
      background: background,
      zIndex: zIndex,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      ...typeProps(),
      '& > div': {
        width: getMeasurement(width),
        height: getMeasurement(height)
      }
    });
    return ccPreloader;
  }, [background, getMeasurement, height, type, width, zIndex]);
  return {
    'cc-Preloader': ccPreloaderStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;